var EDeviceType = /*#__PURE__*/ function(EDeviceType) {
    EDeviceType["MOBILE"] = "mobile";
    EDeviceType["TABLET"] = "tablet";
    EDeviceType["DESKTOP"] = "desktop";
    EDeviceType["WIDESCREEN"] = "widescreen";
    return EDeviceType;
}(EDeviceType || {});
class DeviceType {
    static isBigScreen(deviceType) {
        return [
            "desktop",
            "widescreen"
        ].includes(deviceType);
    }
}
export { EDeviceType, DeviceType };
